import React from 'react';
import PropTypes from 'prop-types';

import * as icons from './svg';

const Icon = props => {
  const {
    type,
    color,
    height,
    width,
    label,
    className,
    iconClassName,
    labelClassName,
    ...restProps
  } = props;
  const TheIcon = icons[type];
  const classes = `icon ${className}`;
  const style = {};
  if (color) {
    style.fill = color;
  }
  const labelOut = label ? <span className={labelClassName}>{label}</span> : null;

  return (
    <div className={classes} style={style} {...restProps}>
      <TheIcon height={height} width={width} className={iconClassName} />
      {labelOut}
    </div>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

Icon.defaultProps = {
  color: undefined,
  height: 32,
  width: 32,
  label: '',
  className: '',
  iconClassName: '',
  labelClassName: '',
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js